import {flowTemplatesBg} from 'assets/images/images';
import {
  DashboardLayout,
  PageLimit,
  Pagination,
  PrimaryButton,
  EmptyState,
  Loader,
} from 'components';
import React, {useMemo, useState} from 'react';
import {connect} from 'react-redux';
import * as Actions from '../../../../store/actions';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import {useNavigate} from 'react-router-dom';
import PageNumber from 'components/PageNumber';
import {useQuery} from 'react-query';
import {fetchRuleTemplates} from '../../../../requests/queries/flows';

function FlowTemplates({auth: {userDetails}}) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState('1');
  const [limit, setLimit] = useState(10);

  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 95);
  const lighterBrandShade = getLighterShade(baseColor, 80);

  const params = useMemo(
    () => ({
      limit,
      page: currentPage,
    }),
    [currentPage, limit],
  );

  const {data, isLoading} = useQuery(['flowTemplates', {params}], () =>
    fetchRuleTemplates({params}),
  );

  const TEMPLATES = useMemo(
    () => (!isLoading && data ? data?.entity : []),
    [data, isLoading],
  );

  const pageClick = selected => {
    setCurrentPage(selected);
  };

  const handleTemplateClick = template => {
    if (!template.id) return;
    navigate(`/flows/templates/${template?.id}`, {
      state: {template},
    });
  };

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Flow Templates</p>
      }
    >
      {isLoading ? (
        <Loader />
      ) : TEMPLATES?.length === 0 ? (
        <EmptyState
          noBtn
          heading="No Data found"
          body="No Rule Template found"
          height={70}
        />
      ) : (
        <div className="py-9 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-8">
          {TEMPLATES.map((template, index) => (
            <div
              key={index}
              style={{
                backgroundColor: lighterShade,
              }}
              className="rounded-2xl border-[0.5px] border-[#EAECF0]"
            >
              <div
                style={{
                  backgroundColor: lighterBrandShade,
                }}
                className="bg-[#D9E5F8] rounded-t-2xl w-full"
              >
                <img
                  src={flowTemplatesBg}
                  className="h-[117px] pt-4 rounded-t-2xl w-full"
                  alt="icon"
                />
              </div>
              <div className="border-t-[0.5px] border-t-[#EAECF0] p-4 rounded-b-2xl">
                <h1 className="text-deepBlue text-base font-medium mb-1">
                  {template?.name || 'N/A'}
                </h1>
                <p className="text-[#5C688E] text-small mb-3 font-normal">
                  {template?.desc || 'N/A'}
                </p>
                <PrimaryButton
                  buttonText="View This Flow"
                  className="!text-xs !p-2"
                  onClick={() => handleTemplateClick(template)}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {!isLoading && TEMPLATES.length > 0 && (
        <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-0 bg-white80 mx-[-32px] px-8 py-[18px] border-[0.5px] border-y-[#E4E3EC] border-transparent">
          <PageNumber
            currentPage={currentPage}
            limit={limit}
            totalCount={TEMPLATES.length || 0}
          />

          <div className="flex items-center gap-5">
            <PageLimit
              onLimitChange={setLimit}
              total={TEMPLATES.length}
              length={TEMPLATES.length}
              limit={limit}
            />

            <Pagination
              total={Math.ceil(TEMPLATES.length / limit)}
              current={+currentPage}
              onPageChange={activePage => {
                localStorage.setItem('page', String(activePage));
                pageClick(activePage);
              }}
            />
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(FlowTemplates);
